<template>
  <div>
    <resource
      resource="gift"
      resourceName="Geschenk"
      :withFiles="true"
      :createMode="true"
      :attributes="[
        {
          name: 'title',
          label: 'Name'
        },
        {
          name: 'gift_category_id',
          label: 'Kategorie',
          type: 'DropdownResourceSelector',
          resource: 'giftCategory',
          nullValue: 'Keine Kategorie (Allgemein)',
          filter: [
            {
              name: 'sort',
              mode: 'ASC',
              attribute: 'name'
            },
            {
              name: 'forSelect'
            }
          ]
        },
        {
          name: 'price',
          label: 'Preis'
        },
        {
          name: 'royalty',
          label: 'Mod Preis'
        },
        {
          name: 'file',
          label: 'Bild',
          type: 'ImageSelector'
        }
      ]"
    >
      <div slot="title">
        <h4>Geschenk erstellen</h4>
      </div>
    </resource>
  </div>
</template>

<script lang="babel">
export default {
}
</script>
